import {
  FieldValues,
  useController,
  UseControllerProps
} from 'react-hook-form';
import { CurrencyInput, NumberInputProps } from '../../atoms';
import { FormField } from './form-field';

type Props<TFieldValues extends FieldValues> = NumberInputProps &
  UseControllerProps<TFieldValues> & {
    label: string;
    sublabel?: string;
  };

export function FieldCurrencyInput<
  TFieldValues extends FieldValues = FieldValues
>({
  id,
  name,
  label,
  sublabel,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  ...props
}: Props<TFieldValues>): JSX.Element {
  const {
    field: { ref: _ref, ...field },
    fieldState
  } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control
  });

  return (
    <FormField
      id={id ?? name}
      name={name}
      label={label}
      sublabel={sublabel}
      error={fieldState.error}
      isRequired={!!rules?.required}
      isDisabled={props.isDisabled}
    >
      <CurrencyInput
        {...field}
        {...props}
        id={id ?? name}
        isRequired={!rules?.required}
      />
    </FormField>
  );
}
